<div
  class="c-form__item u-layout-auto u-width-100"
  [ngClass]="{ 'c-form__error': errorMessage.length > 0 }"
>
  <label [for]="label"
    >{{ label | lsTranslate }} <span *ngIf="required">*</span></label
  >
  <textarea
    [id]="label"
    [attr.maxlength]="maxlength"
    [placeholder]="placeHolder"
    (change)="textValueChanged($event)"
    (keyup)="textValueChanged($event)"
    [attr.value]="text"
    >{{ text }}</textarea
  >
  <div
    id="errorMessage"
    class="c-form__message"
    *ngIf="errorMessage.length > 0"
  >
    {{ errorMessage | lsTranslate }}
  </div>
</div>

<div
  ls-dynamic-translation
  id="This is a required field."
  i18n="TextArea input|Required field error message @@errorMessageRequiredTextArea"
>
  This is a required field.
</div>
